import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryQuickNav() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
      {categories.map((cat) => (
        <Link
          key={cat.key}
          to={`/category?category=${cat.key}`}
          className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-100 p-4 md:p-5 transition-colors hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
        >
          <span className="flex h-12 w-12 md:h-14 md:w-14 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${cat.icon} text-xl md:text-2xl`}></i>
          </span>
          <div className="min-w-0">
            <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
              {cat.name}
            </h3>
            <p className="mt-1 text-xs md:text-sm leading-relaxed text-foreground-600 line-clamp-2">
              {cat.desc}
            </p>
          </div>
          <span className="ml-auto flex h-7 w-7 items-center justify-center text-foreground-400 transition-colors group-hover:text-primary-600">
            <i className="ri-arrow-right-s-line text-xl"></i>
          </span>
        </Link>
      ))}
    </div>
  );
}